import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TripPlannerRoutingModule } from './trip-planner-routing.module';
import { SharedModule } from '../shared/shared.module';
import { CalendarSharedModule } from '../shared/calendar.shared.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TripPlannerRoutingModule,
    SharedModule,
    CalendarSharedModule,
    MatIconModule,
  ],
})
export class TripPlannerModule {
}
